import fetchIntercept from 'fetch-intercept';
import { ShowLoader, HideLoader } from '../utils/Loading-actions';
import { ShowMessageModal } from 'ui-common/src/utils/ResponseHandler-actions';
import { Cookies } from 'react-cookie';
// import store from 'misc/store';
import { checkEnvironment } from 'ui-common/src/lib/utils';
import configData from 'ui-common/src/config';
import { hideErrorNotification } from '../utils/apiUtils';
import { setSecureCookies } from 'ui-common/src/utils/common';
import { ACCESS_TOKEN, REFRESH_TOKEN, TOKEN_TYPE, USER_SESSION } from '../constants';
import * as logoutUtil from '../utils/logout';

const cookies = new Cookies();

let reqCount = 0;
let resCount = 0;
let showLoaderFunc;

function getECMTokenFromRefreshToken() {
  const { ECM_URL } = checkEnvironment();
  const formData = new FormData();
  formData.append('grant_type', 'refresh_token');
  formData.append('refresh_token', cookies.get(REFRESH_TOKEN));
  fetch(`${ECM_URL}/oauth/access_token_withissuer`, {
    method: 'POST',
    body: formData,
    credentials: 'include',
  })
    .then((response) => {
      if (response.status === 200) return response.json();
      // 401 && 403 are handled
      if (response.status === 401 || response.status === 403)
        throw new Error('Refresh Token expired');
      return new Error('something went wrong fetching refresh token');
    })
    .then((data) => {
      setSecureCookies(TOKEN_TYPE, data.token_type);
      setSecureCookies(ACCESS_TOKEN, data.access_token);
      window.location.reload();
    })
    .catch((e) => {
      logoutUtil.logout(logoutUtil.LogoutTrigger.sessionTimeout);
    });
}
function handleLoader() {
  reqCount = 0;
  resCount = 0;
  window.store.dispatch(HideLoader());
  clearTimeout(showLoaderFunc);
}

let needsToCheck = true;
async function refreshUnexpiredSessionCookie() {
  // Allows us to early exit since this function can be called very ofthen.
  if (!needsToCheck) {
    return;
  }

  needsToCheck = false;
  // We should check again after a minute has ellapsed.
  setTimeout(() => {
    needsToCheck = true;
  }, 60000);

  const info = cookies.get(USER_SESSION);
  if (!info) {
    // Feature not enabled.
    return;
  }

  const isValidState = info.timeoutMins && info.promptMins && info.lastRefreshedAt;
  if (!isValidState) {
    return;
  }

  const ellapsedMillis = new Date().getTime() - info.lastRefreshedAt;
  const ellapsedMinutes = ellapsedMillis / 60000; // ms -> minutes

  const extendTime = Math.max(info.timeoutMins / 3, 5);
  const shouldExtendSession = ellapsedMinutes >= extendTime;

  if (shouldExtendSession) {
    try {
      await fetch('/ECM/session/extend', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch {
      // No need to check if success or error.
      // If there was an error, we'll try again later.
    }
  }
}

const withUrlParams = (url) => `${url}(\\?.*)?`;

// This list will be used to create a RegExp that will match any of these APIs
//   * Slash (/) will be automatically escaped (\\/)
//   * Each API must match to the end: $ is automatically added
//   * wrap in `withUrlParams` if the API can have URL params
const nonAuthApiList = [
  '/api/auth/login',
  '/api/auth/token',
  '/api/v1/auth/first-login/password',
  '/api/v1/sso/identity-providers',
  '/api/v1/sso/identity-providers/initiate-login',
  '/oauth/access_token_withissuer',
  withUrlParams('/api/config/ui-track'),
];

const excludeFromAuth = new RegExp(
  nonAuthApiList.map((api) => `${api.replaceAll('/', '\\/')}$`).join('|')
);

/** Exported for testing */
export function needsAuth(url) {
  // gateway endpoints always use cookies
  if (url.includes('/ECMv6/api/')) return false;

  return !excludeFromAuth.test(url);
}

const unregister = fetchIntercept.register({
  request(url, config = {}) {
    const SERVICE_ENDPOINT_PAMMS = checkEnvironment().PAMMS_API_URL;
    const gridApiEndpoints = [
      `${SERVICE_ENDPOINT_PAMMS}/privilegedinstance/v2/list`,
      `${SERVICE_ENDPOINT_PAMMS}/privilegedinstance/sessions`,
      `${SERVICE_ENDPOINT_PAMMS}/privilegedinstance/v2/list`,
    ];
    if (config.headers && needsAuth(url) && !checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN) {
      config.headers.Authorization = `${cookies.get(TOKEN_TYPE)} ${cookies.get(ACCESS_TOKEN)}`;
    }
    if (
      gridApiEndpoints.includes(url) ||
      (url.indexOf('http') === 0 && new URL(url).origin !== window.location.origin)
    )
      return [url, config];
    // Show Loading
    if (!config.headers) config.headers = {};
    if (reqCount === 0 && !config.headers['X-NOLOADER']) {
      showLoaderFunc = setTimeout(() => {
        window.store.dispatch(ShowLoader());
      }, configData.loaderMinDelay);
    }
    reqCount += 1;

    // Modify the url or config here
    return [url, config];
  },
  requestError(error) {
    // Called when an error occured during another 'request' interceptor call
    return Promise.reject(error);
  },
  response(response) {
    // Hide Loading
    const SERVICE_ENDPOINT_PAMMS = checkEnvironment().PAMMS_API_URL;
    const gridApiEndpoints = [
      `${SERVICE_ENDPOINT_PAMMS}/privilegedinstance/v2/list`,
      `${SERVICE_ENDPOINT_PAMMS}/privilegedinstance/sessions`,
      `${SERVICE_ENDPOINT_PAMMS}/privilegedinstance/v2/list`,
    ];
    window.fetchResponse = response;
    if (
      !gridApiEndpoints.includes(response.url) &&
      !(
        response.url.indexOf('http') === 0 &&
        new URL(response.url).origin !== window.location.origin
      )
    ) {
      resCount += 1;
      if (reqCount === resCount) {
        handleLoader();
      }
    }
    // Modify the reponse object

    if (
      response.status === 401 &&
      response.url.indexOf('/api/auth/login') === -1 &&
      !window.location.pathname.startsWith('/ECMv6/auth/')
    ) {
      if (
        cookies.get(ACCESS_TOKEN) &&
        cookies.get(REFRESH_TOKEN) &&
        response.url.indexOf('/oauth/access_token') === -1
      ) {
        if (!checkEnvironment().SSO_LOGIN) {
          return getECMTokenFromRefreshToken();
        }
      }

      logoutUtil.logout(logoutUtil.LogoutTrigger.fetchIntecept);
      return null;
    }
    if (
      response.status !== 200 &&
      response.status !== 201 &&
      response.status !== 204 &&
      response.status !== 401 &&
      response.status !== 503 &&
      response.status !== 412 &&
      !response.request?.headers.has('X-NOERRORMODAL')
    ) {
      // return Promise.reject(error);
      // All Errors Handling
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        response
          .clone()
          .json()
          .then((res) => {
            let errorMessage = 'ErrorMessage.fetch.default';
            if (res.error) {
              errorMessage = res.error;
            } else if (res.message) {
              errorMessage = res.message;
            }
            if (!hideErrorNotification(response.url)) {
              window.store.dispatch(
                ShowMessageModal({
                  message: errorMessage,
                  data: res.data,
                  encrypted: true,
                  status: 'failure',
                })
              );
            }
          })
          .catch((jsonError) => {
            // Fallback for JSON parsing errors
            if (!hideErrorNotification(response.url)) {
              window.store.dispatch(
                ShowMessageModal({
                  message: 'ErrorMessage.fetch.default',
                  encrypted: true,
                  status: 'failure',
                })
              );
            }
          });
      } else {
        // Non-JSON response, show generic error
        if (!hideErrorNotification(response.url)) {
          window.store.dispatch(
            ShowMessageModal({
              message: 'ErrorMessage.fetch.default',
              encrypted: true,
              status: 'failure',
            })
          );
        }
      }
    } else if (response.status === 503) {
      window.store.dispatch(
        ShowMessageModal({
          message: 'ServiceUnavailable',
          ecrypted: true,
        })
      );
    }

    // Refresh session cookie
    if (response.status === 200) {
      refreshUnexpiredSessionCookie();
    }

    return response;
  },

  responseError(error) {
    // Hide Loading
    // resCount++;
    // if (reqCount === resCount) {
    //   handleLoader();
    // }

    if (
      [
        'Failed to fetch', // Chromium
        'NetworkError when attempting to fetch resource.', // Firefox
        'Load failed', // WebKit
      ].includes(error.message) &&
      !error.request?.headers.has('X-NOERRORMODAL')
    ) {
      window.store.dispatch(
        ShowMessageModal({
          message: 'ServiceUnavailable',
          ecrypted: true,
          status: 'failure',
        })
      );
    }
    // Handle an fetch error
    return Promise.reject(error);
  },
});

export default unregister;
